<template>
  <div
    id="newPasswordModal"
    class="modal fade auth-modal"
    tabindex="-1"
    aria-labelledby="newPasswordModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h2>Сменить пароль</h2>
          <button ref="closeButton" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form v-if="!text" class="mt-4" @submit.prevent="setPassword">
            <div class="mb-3">
              <label for="currentPassword" class="form-label">Новый пароль</label>
              <input
                id="currentPassword"
                v-model="user.new_password"
                type="password"
                class="form-control"
                autocomplete="new-password"
                required
              />
            </div>
            <div class="mb-3">
              <label for="newPassword" class="form-label">Подтвердите новый пароль</label>
              <input
                id="newPassword"
                v-model="confirmPassword"
                type="password"
                class="form-control"
                autocomplete="new-password"
                required
              />
              <div v-if="confirmPassword && !isPasswordMatching" class="error" role="alert">Пароли не совпадают</div>
            </div>
            <button type="submit" class="black-button mt-4">Сохранить</button>
          </form>
          <p v-else>{{ text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref, onMounted, computed } from 'vue';
  import AuthService from '../../services/auth';
  import { Modal } from 'bootstrap';
  import { useRoute } from 'vue-router';

  export default defineComponent({
    nmae: 'NewPasswordModal',
    setup() {
      const route = useRoute();
      const user = ref({
        uid: route.query.uid,
        token: route.query.token,
        new_password: '',
      });
      const confirmPassword = ref('');
      const text = ref(null);
      let modalInstance = null;

      const isPasswordMatching = computed(() => {
        return user.value.new_password === confirmPassword.value;
      });

      const setPassword = async () => {
        AuthService.resetPasswordConfirm(user.value)
          .then((response) => {
            text.value = 'Ваш пароль успешно обновлен';
            return Promise.resolve(response);
          })
          .catch((error) => {
            alert('Не удалось обновить пароль');
            return Promise.reject(error);
          });
      };
      const openModal = () => {
        if (modalInstance) {
          modalInstance.show();
        }
      };

      onMounted(() => {
        const modalElement = document.getElementById('newPasswordModal');
        if (modalElement) {
          modalInstance = new Modal(modalElement);
        } else {
          console.error('Модальное окно не найдено');
        }
      });
      return {
        user,
        text,
        isPasswordMatching,
        confirmPassword,
        setPassword,
        openModal,
      };
    },
  });
</script>
